<template>
  <div class="agency-setting-bar">
    <div class="agency-setting-bar-info">
      <div class="agency-setting-bar-title">{{ this.info.title }}</div>
      <div class="agency-setting-bar-summary">{{ this.info.summary }}</div>
    </div>
    <div class="agency-setting-bar-action-block">
      <div class="agency-setting-bar-action poster"
           @click="handlePosterAction"
      >
        {{ info.poster.text }}
      </div>
      <div class="agency-setting-bar-action"
           @click="handleAction"
      >
        {{ info.btn.text }}
      </div>
    </div>
  </div>
</template>

<script>
  import { locationHref } from '@/utils';

  export default {
    name: 'AgencySettingBar',
    props: {
      info: {
        type: Object,
        required: true,
      },
    },
    methods: {
      handlePosterAction() {
        locationHref(this.info.poster.path);
      },
      handleAction() {
        locationHref(this.info.btn.path);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .agency-setting-bar {
    box-sizing: border-box;
    padding: 0 @size-base;
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f3fbfc;

    &-info {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
    }

    &-title {
      margin-bottom: @size-extra-small;
      color: @color-primary-aide;
      font-size: @font-size-medium;
      font-weight: @font-weight-bold;
      line-height: 1;
    }

    &-summary {
      color: @color-text-light;
      font-size: @font-size-extra-small;
      line-height: 1;
    }

    &-action-block {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-action {
      flex-shrink: 0;
      width: 160px;
      height: @size-large;
      display: flex;
      align-items: center;
      justify-content: center;
      color: @color-primary-aide;
      font-size: @font-size-small;
      border: @border-width-base @border-style-base @color-primary-aide;
      border-radius: @border-radius-large * 2;

      &.poster {
        margin-right: @size-base;
      }
    }
  }

</style>
